import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class DigitizationService {
  constructor(private http: HttpClient) {}

  public fetchBuilding(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/digitization/building/${id}`
    return this.http.get(url, {})
  }

  public updateBuilding(id: any, payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/digitization/building/${id}`
    return this.http.put(url, payload)
  }

  public createBuilding(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/digitization/building`
    return this.http.post(url, payload)
  }
}
